import React from 'react'
import styled from 'styled-components'

import { COLORS, SIZES } from '~/common/globalStyles'

export const FormContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
`

export const FormBodyContainer2 = styled.div`
  flex: 1;
`

const FormBodyWrapper = styled.div`
  flex: 1;
  min-height: 0;

  &.spaced-container {
    > div {
      display: flex;
      flex-direction: column;
    }
  }
`

interface Props {
  className?: string
  children?: React.ReactNode
}

export const FormBodyContainer: React.FC<Props> = (props) => {
  return (
    <FormBodyWrapper className={props.className}>
      <div style={{ height: '100%', overflow: 'scroll' }}>{props.children}</div>
    </FormBodyWrapper>
  )
}

export const FormBody = styled.form`
  flex: 1;
  display: flex;
  flex-direction: column;
  padding: ${SIZES.xl};
  && > * + * {
    margin-top: ${SIZES.large};
  }
`

export const FormDragNDropBody = styled.div(
  ({ theme }) => `
  flex: 1;
  display: flex;
  flex-direction: column;
  padding: 0px;
  && > * + * {
    margin-top: ${theme.spacing(3)};
  }
`,
)

export const FormFooter = styled.div`
  padding: ${SIZES.large};
  border-top: 1px solid ${COLORS.lighterGray};
`
